import { Vector3 } from "three";

import { Context } from "../../../context";
import { ControllerStrategy } from "../strategy";

/**
 * Ensures that a camera is initialised above a certain height
 */
export class MinHeightControllerStrategy extends ControllerStrategy {
  minHeight = 3;
  temp = new Vector3();

  init(context: Context): ControllerStrategy {
    super.init(context);

    const controls = this.registered?.controls;
    if (controls) {
      controls.getTarget(this.temp);

      if (this.temp.y < this.minHeight) {
        this.temp.setY(this.minHeight);
        controls.setTarget(this.temp.x, this.temp.y, this.temp.z);
      }
    }

    return this;
  }
}
